import {
  TabSectionType,
  WorkspaceTab,
  WorkspaceTabSection,
} from '@ansys-internal/awf-angular/contributions';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { ConceptSections } from '../../../../../shared/enums';
import { sectionState } from '../../../../../shared/models/section-state';
import { AWFSection } from '@ansys-internal/awf-angular/core';
import { IconType } from '@ansys-internal/awc-angular/icons';
@AWFSection({
  path: ConceptSections.ARCHITECTURE,
})
export class ArchitectureSection implements TabSectionType {
  public type: ConceptSections = ConceptSections.ARCHITECTURE;
  public title: string = 'Architecture';
  public icon: IconType = { icon: Icons.FORCE_ANGLE };
  public disabled: boolean = !sectionState.architecture;
  async getTitle(
    tab: WorkspaceTab,
    section: WorkspaceTabSection
  ): Promise<string> {
    return this.title;
  }

  async getIcon(
    tab: WorkspaceTab,
    section: WorkspaceTabSection
  ): Promise<IconType> {
    return this.icon;
  }

  public isDisabled(): Promise<boolean> {
    return new Promise((resolve) => {
      resolve(!sectionState.architecture);
    });
  }
  onChangeRequest(): void {
    this.disabled = !sectionState.architecture;
  }
}
